import { EntityModel } from '@/interfaces'
import {
  ALL_TRAVEL_TYPES_BLOCKS_QUERY,
  CREATE_TRAVEL_TYPES_BLOCK_MUTATION,
  DELETE_TRAVEL_TYPES_BLOCK_MUTATION,
  FORCE_DELETE_TRAVEL_TYPES_BLOCK_MUTATION,
  SINGLE_TRAVEL_TYPES_BLOCK_QUERY,
  UPDATE_TRAVEL_TYPES_BLOCK_MUTATION,
} from './graphql'

const cmsTravelTypesBlockModel: EntityModel = {
  name: 'travelTypesBlock',
  namePlural: 'travelTypesBlocks',
  uniqueName: 'cmsTravelTypesBlock',
  uniqueNamePlural: 'cmsTravelTypesBlocks',
  path: 'cms/blocks/travel_types_block',
  baseUrl: '/cms/blocks/travel_types_blocks',
  translationPrefix: 'entities:cmsTravelTypesBlock.',
  getDisplayName: (values: any) => {
    return 'Travel Types Block'
  },
  gql: {
    getAll: ALL_TRAVEL_TYPES_BLOCKS_QUERY,
    getSingle: SINGLE_TRAVEL_TYPES_BLOCK_QUERY,
    create: CREATE_TRAVEL_TYPES_BLOCK_MUTATION,
    update: UPDATE_TRAVEL_TYPES_BLOCK_MUTATION,
    delete: DELETE_TRAVEL_TYPES_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_TRAVEL_TYPES_BLOCK_MUTATION,
  },
  attributes: {
    layout: {
      name: 'layout',
      label: 'entities:cmsTravelTypesBlock.attributes.layout.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'default',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsTravelTypesBlockModel
